import type { UseActionResult, UseMutationProps } from '@ztechapps/common.hook'
import { useError } from '@ztechapps/common.hook'
import { useConfirmDialog } from '@ztechapps/common.hook'
import type { WorkOrder } from '@ztechapps/common.contract'
import { useUnlinkWorkOrerTask } from './useUnlinkWorkOrerTask'

export type UnlinkTaskArgs = {
  taskIds: string[]
  workOrderId: string
}
export const useUnlinkTaskToWorkOrder = (
  props = {} as UseMutationProps
): UseActionResult<WorkOrder, UnlinkTaskArgs> => {
  const { onError } = useError()

  const [onUnlinkProjectTask, { error, loading }] = useUnlinkWorkOrerTask(props)

  const { confirm } = useConfirmDialog({
    text: `Are you sure you unlink the task(s) from this production?`,
    title: 'Unlink task(s)',
    buttons: { confirm: { text: 'Yes, unlink it!' } },
  })

  const onUnlinkTask = async ({ taskIds, workOrderId }: UnlinkTaskArgs) => {
    try {
      return await confirm(async () => {
        //remove the workOrderItem id from the task
        return await onUnlinkProjectTask({
          taskIds,
          workOrderId,
        })
      })
    } catch (e) {
      onError(e)
    }
  }

  return [onUnlinkTask, { error, loading }]
}
